import { Button, ButtonsContainer } from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";
import React from "react";

type ModalFooterProps = {
  onRequestClose: () => void;
  fycRedirectUrl?: string;
};

export const ModalFooterCta: React.FC<ModalFooterProps> = ({
  onRequestClose,
  fycRedirectUrl
}) => {
  return (
    <ButtonsContainer>
      <Button
        renderAs="button"
        variant="text"
        size="regular"
        onClick={onRequestClose}
        dataContentPiece="back_to_itinerary"
      >
        <Trans>Back to itinerary</Trans>
      </Button>

      <Button
        renderAs="a"
        variant="primary"
        size="regular"
        href={fycRedirectUrl}
        dataContentPiece="find_another_cruise"
      >
        <Trans>Find another cruise</Trans>
      </Button>
    </ButtonsContainer>
  );
};
